<template>
  <div class="_info-overview">
    <div class="_info-top">
      <img :src="avatar.value" v-if="avatar"/>
      <div v-else class="_info-avatar" :style="avatarStyle">{{name.match(/\S/)[0].toUpperCase()}}</div>
      <span class="_info-uname">{{name}}</span>
    </div>
    <div class="_info-center">
      <ul class="_info-props" :style="{'min-height': propsReady ? '0': '200px'}">
        <c-loading v-if="!propsReady"></c-loading>
        <li v-for="(prop, i) in props" :key="prop.name + '_' + i">
          <span class="_info-prop-name">{{prop.text}}</span>
          <span class="_info-prop-value" v-if="prop.name === 'duration'">{{(Number(prop.value) / 1000).toFixed(0)}}秒 在线</span>
          <span class="_info-prop-value" v-else-if="prop.name === 'name'">{{/匿名/.test(name) ? '' : name}}</span>
          <span class="_info-prop-value" v-else>{{prop.value}}</span>
        </li>
      </ul>
      <ul class="_info-recent-events" :style="{'min-height': recentReady ? '0' : '200px'}">
        <c-loading v-if="!recentReady"></c-loading>
        <li class="_info-title">最近30天行为统计</li>
        <li v-if="!recentEvents.length" class="_info-empty">暂无数据</li>
        <li class="_info-recent-event" v-for="(event) in recentEvents" :key="event.eventId">
          <span class="_info-event-name">{{getEventName(event.name)}}</span>
          <span class="_info-event-times">{{event.cnt}}次</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { util } from '../../utils';
export default {
  name: "userInfoProps",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      eventNameMap(state) {
        return state.bizSys.eventNameMap
      },
      props(state) {
        return state.bizUserInfo.userProps;
      },
      recentEvents(state) {
        return state.bizUserInfo.recentEvents;
      },
      recentReady(state) {
        return state.bizUserInfo.ready.recentEvents;
      },
      propsReady(state) {
        return state.bizUserInfo.ready.userProps;
      },
    }),
    name() {
      const nameProp = this.props.find((item) => item.name === "name")
      const id = this.props.find((item) => item.name === "app_user_id")
      const zgId = this.props.find((item) => item.name === "zg_id")
      if (id && id.value) {
        return nameProp && nameProp.value ? nameProp.value : id && id.value ? id.value : '-'
      } else {
        return zgId ? `匿名用户${zgId.value}` : '-'
      }
    },
    avatar() {
      return this.props.find((item) => item.name === "avatar");
    },
    avatarStyle() {
      const style = {
        background: util.getColorByName(this.name)
      }
      return style
    },
  },
  methods: {
    getEventName (name) {
      const event = this.eventNameMap[name]
      return event ? event.alias_name || name : name
    }
  },
};
</script>
<style lang="sass">
@import './styles/props'
</style>